<template>
	<div class="product-service-page">
		<!-- 首屏横幅 -->
		<section class="hero-section">
			<div class="hero-container">
				<h1>{{ heroTitle }}</h1>
				<p class="subtitle">{{ heroSubtitle }}</p>
			</div>
		</section>

		<!-- 各服务模块 -->
		<section id="shipping" ref="shipping" class="section-wrapper">
			<Shipping />
		</section>

		<section id="refrigerated" ref="refrigerated" class="section-wrapper">
			<RefrigeratedGoods />
		</section>

		<section id="operable" ref="operable" class="section-wrapper">
			<OperableGoods />
		</section>

		<section id="consultation" ref="consultation" class="section-wrapper">
			<Consultation />
		</section>
	</div>
</template>

<script>
	import Shipping from './Shipping.vue';
	import RefrigeratedGoods from './RefrigeratedGoods.vue';
	import OperableGoods from './OperableGoods.vue';
	import Consultation from './Consultation.vue';

	export default {
		name: 'Services',
		components: {
			Shipping,
			RefrigeratedGoods,
			OperableGoods,
			Consultation,
		},
		data() {
			return {
				selectedSection: 'shipping',
				observer: null,
			};
		},
		computed: {
			heroTitle() {
				return this.$t('hero.title');
			},
			heroSubtitle() {
				return this.$t('hero.subtitle');
			}
		},
		methods: {
			scrollToSection() {
				const section = this.selectedSection;
				const sectionElement = this.$refs[section];
				if (sectionElement) {
					sectionElement.scrollIntoView({
						behavior: 'smooth'
					});
				}
			},
			initIntersectionObserver() {
				const options = {
					threshold: 0.1,
				};
				this.observer = new IntersectionObserver((entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							entry.target.classList.add('visible');
						}
					});
				}, options);

				const sections = document.querySelectorAll('.section-wrapper');
				sections.forEach((section) => {
					this.observer.observe(section);
				});
			},
		},
		mounted() {
			this.initIntersectionObserver();
		},
		beforeDestroy() {
			if (this.observer) {
				this.observer.disconnect();
			}
		},
	};
</script>

<style lang="scss" scoped>
	.product-service-page {
		font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
		color: #333;
		line-height: 1.6;
		background: linear-gradient(rgba(245, 250, 255, 0.92), rgba(245, 250, 255, 0.92)),
			url('../assets/images/背景1.jpg') center/cover no-repeat;
		background-attachment: fixed;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		padding-bottom: 60px;
	}

	/* Hero Section */
	.hero-section {
		position: relative;
		color: #fff;
		min-height: 320px;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		overflow: hidden;

		&::before {
			content: '';
			position: absolute;
			inset: 0;

			/* 背景图 + 背景色（渐变或纯色） */
			background:
				linear-gradient(rgba(0, 48, 87, 0.75), rgba(0, 48, 87, 0.75));
			filter: brightness(0.9) blur(1px);
			z-index: 0;

			@media (max-width: 768px) {
				background-position: center center;
				filter: brightness(0.9);
			}
		}

		.hero-container {
			position: relative;
			z-index: 1;
			max-width: 1000px;
			padding: 0 20px;
		}

		h1 {
			font-size: clamp(2.2rem, 5vw, 3.2rem);
			font-weight: 800;
			margin-bottom: 18px;
			text-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
		}

		.subtitle {
			font-size: clamp(1.1rem, 3.5vw, 1.6rem);
			font-weight: 400;
			text-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
			line-height: 1.6;
			opacity: 0.95;
		}
	}

	/* Section Wrapper with Animation */
	.section-wrapper {
		max-width: 1200px;
		margin: 60px auto;
		padding: 0 20px;
		opacity: 0;
		transform: translateY(30px);
		transition: opacity 0.6s ease, transform 0.6s ease;

		&.visible {
			opacity: 1;
			transform: translateY(0);
		}

		@media (min-width: 768px) {
			margin: 80px auto;
			padding: 0 60px;
		}

		@media (min-width: 1200px) {
			padding: 0 100px;
		}

		@media (max-width: 480px) {
			padding: 0 15px;
		}
	}
</style>